import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterLinksSection from './components/ClusterLinksSection';
import WhatMotivationMeans from './components/WhatMotivationMeans';
import WhenProblemIsManagement from './components/WhenProblemIsManagement';
import ManagementStartsWithResult from './components/ManagementStartsWithResult';
import CoreCompetencies from './components/CoreCompetencies';
import TeamAutonomy from './components/TeamAutonomy';
import DifferentMotivation from './components/DifferentMotivation';
import DifficultEmployees from './components/DifficultEmployees';
import ControlVsManagement from './components/ControlVsManagement';
import StrongTeamFormation from './components/StrongTeamFormation';
import FormatsSection from './components/FormatsSection';
import HowProgramGoes from './components/HowProgramGoes';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function MotivationTeamManagementPage() {
  return (
    <>
      
      <SeoTitle title="Мотивация и управление командой | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <ClusterLinksSection />
        <WhatMotivationMeans />
        <WhenProblemIsManagement />
        <ManagementStartsWithResult />

        <div id="skills">
          <CoreCompetencies />
        </div>

        <TeamAutonomy />
        <DifferentMotivation />
        <DifficultEmployees />
        <ControlVsManagement />
        <StrongTeamFormation />
        <FormatsSection />

        <div id="process">
          <HowProgramGoes />
        </div>

        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}